import styles from './StatusChip.module.scss';
import cx from 'classnames';
import { Text } from 'components';
import { UserStatus } from 'types';

type Props = {
  status: UserStatus;
  className?: string;
};

export const StatusChip = ({ status, className = '' }: Props) => {
  const currentStatus = status.slice(0, 1).toUpperCase() + status.slice(1).toLowerCase();
  return (
    <div className={cx(styles.chip, styles[status.toLowerCase()], className)}>
      <Text type="body2">{currentStatus}</Text>
    </div>
  );
};
